var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalender1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 14.5,
    stroke: "black",
    strokeOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M42.2171 27.2471C43.0653 27.2471 43.7592 27.9411 43.7592 28.7893V38.2891C43.7592 42.9156 41.446 46 36.0483 46H23.7109C18.3133 46 16 42.9156 16 38.2891V28.7893C16 27.9411 16.694 27.2471 17.5422 27.2471H42.2171Z",
    fill: "#9D9DAC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2047 17.5624V15.1566C37.2047 14.5243 36.6803 14 36.048 14C35.4157 14 34.8914 14.5243 34.8914 15.1566V17.4699H24.8672V15.1566C24.8672 14.5243 24.3429 14 23.7106 14C23.0783 14 22.554 14.5243 22.554 15.1566V17.5624C18.3901 17.948 16.3698 20.4309 16.0614 24.1167C16.0305 24.5639 16.4006 24.9341 16.8325 24.9341H42.9262C43.3734 24.9341 43.7435 24.5485 43.6973 24.1167C43.3888 20.4309 41.3686 17.948 37.2047 17.5624Z",
    fill: "#9D9DAC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5257 40.556L34.3845 39.4148C34.9705 38.5204 35.3252 37.4408 35.3252 36.2842C35.3252 33.1382 32.7652 30.5781 29.6191 30.5781C26.4731 30.5781 23.9131 33.1382 23.9131 36.2842C23.9131 39.4303 26.4731 41.9902 29.6191 41.9902C30.7758 41.9902 31.8553 41.6356 32.7498 41.0495L33.891 42.1907C34.1223 42.4221 34.4153 42.53 34.7083 42.53C35.0014 42.53 35.2944 42.4221 35.5257 42.1907C35.9729 41.7435 35.9729 41.0033 35.5257 40.556Z",
    fill: "#9D9DAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender1);
export default __webpack_public_path__ + "static/media/calender-1.571ef70eeab38a4d7027ffc38e519565.svg";
export { ForwardRef as ReactComponent };